import { render, staticRenderFns } from "./portraitHome.vue?vue&type=template&id=62068982&scoped=true"
import script from "./portraitHome.vue?vue&type=script&lang=js"
export * from "./portraitHome.vue?vue&type=script&lang=js"
import style0 from "./portraitHome.vue?vue&type=style&index=0&id=62068982&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62068982",
  null
  
)

export default component.exports